/**
 * @description 异常捕获的状态拦截，请勿修改
 */
 const state = () => ({
  noticeCount: 0,
})
const getters = {
  noticeCount: (state) => state.noticeCount,
}
const mutations = {
  updateNoticeCount(state, count) {
    state.noticeCount = count
  },
}
const actions = {
  updateNoticeCount({ commit }, count) {
    commit('updateNoticeCount', count)
  },
}
export default { state, getters, mutations, actions }
